import React, {useRef, useImperativeHandle} from 'react';

import { Form } from "react-bootstrap";

export default React.forwardRef((props, ref) => {
  return (
    <Form.Control as="select"
      className="selectpicker"
      defaultValue={props.value}
      onChange={(e) => props.onChange(e.target.value)}
    >
      {props.options.map((name) =>
        <option
          key={name.id}
          value={name.value}
          title={name.title}
          onClick={props.onCommit}
        >
          {name.text || name.value}
        </option>
      )}
    </Form.Control>
  );
});
